module.exports = __webpack_public_path__ + "img/expostyle_0950_white.57b02bbd.jpg";